(function () {
  // Only run on mobile viewports
  if (window.matchMedia("(min-width: 750px)").matches) return;

  function initVideoObserver() {
    const videos = document.querySelectorAll(".thumbnail-autoplay-video");
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
            video.classList.add("is-playing");
          } else {
            video.pause();
            video.classList.remove("is-playing");
          }
        });
      },
      { threshold: 0.5 },
    );

    videos.forEach((video) => observer.observe(video));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initVideoObserver);
  } else {
    initVideoObserver();
  }
})();
